import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { RightFilledChevronIcon } from "wm-graphics";
import "./Breadcrumbs.scss";

import getTestIDs from "../../../utils/getTestIDs";

export const testIDs = getTestIDs();

export class Breadcrumbs extends React.Component {
  static defaultProps = {};

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Id associated with component */
    id: PropTypes.any,
    /** Children Link Components to be rendered */
    children: PropTypes.node,
  };

  renderChildren = () => {
    const { children } = this.props;
    const arrayChildren = React.Children.toArray(children);
    const renderedChildren = React.Children.map(
      arrayChildren,
      (child, index) => {
        const isLast = index === arrayChildren.length - 1;
        if (isLast) {
          return (
            <div className="breadcrumb" data-testid={testIDs.Breadcrumb__last}>
              {React.cloneElement(child)}
            </div>
          );
        }

        return (
          <div className="breadcrumb" data-testid={testIDs.Breadcrumb}>
            {React.cloneElement(child)}
            <RightFilledChevronIcon
              width="16"
              height="16"
              data-testid={testIDs.chevron}
            />
          </div>
        );
      }
    );

    return renderedChildren;
  };

  render() {
    const { className, id } = this.props;

    const breadcrumbsClass = classNames("Breadcrumbs", className);

    return (
      <div
        className={breadcrumbsClass}
        id={id}
        data-testid={testIDs.Breadcrumbs}
      >
        {this.renderChildren()}
      </div>
    );
  }
}

export default Breadcrumbs;
